<template>
  <div id="main">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="header_template">
            <div class="profile_user">
              <h3>PHONG THUỶ NHÀ Ở</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"/>
      <div class="row">
        <div class="col-sm-12">
          <div class="progress">
            <div 
              class="progress-bar" 
              role="progressbar" 
              aria-valuenow="10" 
              aria-valuemin="0" 
              aria-valuemax="100" 
              style="width:10%"/>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 content">
          <h3>TỔNG QUAN</h3>
          <ul>
            <li>- Bạn thân mến! Chúng tôi không sử dụng phong thủy Bát trạch. Phương pháp Bát Trạch chỉ  dùng năm sinh để tính toán hướng nhà theo Đông Tứ  Trạch và Tây Tứ Trạch, nên nó tồn tại nhiều khiếm khuyết lớn. Thực tế hai người cùng giới tính, cùng tuổi, ở hướng nhà giống nhau nhưng sướng khổ lại khác nhau. Đó là vì hướng nhà đó có phù hợp với ngày tháng năm sinh của gia chủ hay không, chứ không chỉ đơn thuần là năm sinh như Bát trạch vẫn tính. Hơn nữa, đất có vận đất, thời kỳ này suy, thời kỳ khác thịnh, tùy thuộc vào sự luân chuyển của các hành tinh trong vũ trụ khi phối với tọa số của hướng nhà. Vì thế, chúng tôi sử dụng phương pháp tìm kiếm ngũ hành trong tứ trụ để tư vấn hướng nhà cho bạn, nó có tính khoa học và độ tin cậy cao hơn. Ngũ hành Kim - Thủy - Mộc - Hỏa - Thổ như 05 bánh xe chuyên chở cuộc đời. Nếu cỗ xe thiếu đi một vài bánh thì việc tiến về phía trước sẽ không dễ dàng. Nếu cỗ xe đủ 05 bánh nhưng lại có bánh non bánh cứng thì số phận cũng vất vả nhọc nhằn. Vì vậy, khi phân tích đủ tứ trụ (năm tháng ngày giờ sinh), sẽ thấy được bức tranh ngũ hành trong cuộc đời bạn, nó chính xác hơn nhiều so với "cung phi, cung mệnh" của năm sinh. Nguyên lý cải vận đầu tiên là phải cân bằng ngũ hành, cũng giống như giúp cho cỗ xe cuộc đời đủ bánh và các lốp căng hơi đều nhau vậy. Như thế, chuyến xe sẽ dễ điều khiển hơn, số phận ít ghập ghềnh hơn và từ đó có thể làm thay đổi đời bạn. Qua phân tích tứ trụ của bạn chúng tôi thấy rằng: </li>
          </ul>

          <div class="progress">
            <div 
              class="progress-bar" 
              role="progressbar" 
              aria-valuenow="10" 
              aria-valuemin="0" 
              aria-valuemax="100" 
              style="width:10%"/>
          </div>

          <div v-if="nha_o.length > 0">
            <ul
              v-for="item in nha_o">
              <li><b>{{ item }}</b></li>
            </ul>
          </div>

          <ul>
            <li>Theo phong thủy huyền không, mỗi căn nhà, thửa đất hay ngôi mộ đều luôn luôn biến đổi. Chậm thì 20 năm tính là một vận. Nhanh thì chuyển động theo từng năm, từng tháng thậm chí từng ngày, từng giờ. Nguyên nhân của sự đổi thay đó là do sự phân công cai quản của cửu tinh, tức là 09 ngôi sao, gọi là Cửu Tinh Bắc Đẩu, luân phiên làm chủ quản, trên sai khiến quỷ thần, dưới thống lĩnh nhân gian, sức mạnh vô cùng to lớn. Nếu xây nhà mới, hướng nhà tốt nhất của Bạn chúng tôi đã nói ở trên. Đây là phương pháp biện chứng dựa trên phân tích ngũ hành trong tứ trụ (năm – tháng – ngày – giờ sinh) của bạn, nó đáng tin cậy hơn rất nhiều so với việc chỉ dùng năm sinh để luận hướng nhà theo phong thủy bát trạch. Trường hợp nhà bạn không thể có hướng tốt nhất như trên, hãy đọc kỹ nội dung bên dưới để xây cho mình một căn nhà tốt nhất. Lưu ý rằng, những khuyến nghị này chỉ có giá cho những căn nhà xây dựng từ năm 2004 - 2023.</li>
          </ul>

          <div class="col-sm-12">
            <h5>a.Nhà tọa Tây Bắc hướng Đông Nam:</h5>
            <ul>
              <li>- Góc Đông Nam dễ bề tiến chức: gia chủ nên đặt ấn thăng quan, kê giường, mở cổng để công danh thuận lợi.</li>
              <li>- Góc Đông Bắc có họa hao tài: gia chủ tránh mở cổng, kê giường hay sửa chữa, nên đặt vào đó bình hồ lô bát tiên bằng đồng.</li>
              <li>- Góc Tây Bắc chứa nguồn châu báu: gia chủ nên đặt bảo bình chiêu tài, cóc ba chân, long quy bằng kim loại hoặc mở cổng, kê giường cũng tốt.</li>
              <li>- Góc phía Tây dễ gặp đào hoa: Người có gia đình tránh mở cửa, kê giường. Người độc thân thì làm ngược lại, cũng có thể đặt chậu hoa tươi hoặc treo tranh hoa mẫu đơn vào đó để kết tóc xe tơ.</li>
            </ul>
            <h5>b.Nhà tọa Bắc hướng Nam:</h5>
            <ul>
              <li>- Góc Đông Nam dễ bề tiến chức: gia chủ nên đặt ấn thăng quan, kê giường, mở cổng để công danh thuận lợi.</li>
              <li>- Góc Đông Bắc và chính Tây dễ được thông minh kỳ sỹ: gia chủ nên đặt bàn học, tháp văn xương tại đây</li>
              <li>- Góc Tây Bắc chứa bi quan, chán nản, giảm sút tiền tài: gia chủ nên đặt nghê, hồ lô đồng để hóa giải.</li>
            </ul>

            <h5>c.Nhà tọa Đông Bắc hướng Tây Nam:</h5>
            <ul>
              <li>- Góc Đông Nam có họa hao tài, kiện tụng: gia chủ tránh mở cổng, kê giường hay sửa chữa, nên đặt vào đó bình hồ lô bát tiên bằng đồng.</li>
              <li>- Góc Đông Bắc được lộc văn chương : gia chủ nên đặt bàn học, tháp văn xương tại đây để thông minh, sáng trí.</li>
              <li>- Góc Tây Bắc dễ bề tiến chức: gia chủ nên đặt ấn thăng quan, kê giường, mở cổng để công danh thuận lợi.</li>
              <li>- Góc phía Tây lộc sinh con quý tử: Gia chủ nên đặt tượng kỳ lân hoặc ngọc bích để dễ sinh con trai.</li>
            </ul>


            <h5>d.Nhà tọa Đông hướng Tây:</h5>
            <ul>
              <li>- Góc Đông Nam chứa bi quan, buồn nản: gia chủ nên hồ lô đồng đựng nước để hóa giải.</li>
              <li>- Góc Đông Bắc dễ bề tiến chức: gia chủ nên đặt ấn thăng quan, kê giường, mở cổng để công danh thuận lợi</li>
              <li>- Góc Tây Bắc dễ bề tài lộc: gia chủ nên đặt bảo bình chiêu tài, cóc ba chân hoặc mở cổng, kê giường cũng tốt.</li>
              <li>- Góc phía Tây đầu óc lú lẫn: giả chủ không nên mở cổng, kê giường, đặt bàn học, nên dùng bồn nước hoặc hồ lô đồng đựng nước để hóa giải.</li>
            </ul>


            <h5>e.Nhà tọa Đông Nam hướng Tây Bắc:</h5>
            <ul>
              <li>- Góc Đông Nam sinh vất vả khó khăn: Gia chủ tránh mở cổng, kê giường, nên dùng bể nước hóa giải.</li>
              <li>- Góc Đông Bắc được lộc văn chương : gia chủ nên đặt bàn học, tháp văn xương tại đây để thông minh, sáng trí.</li>
              <li>- Góc Tây Bắc dễ bề tài lộc: gia chủ nên đặt bảo bình chiêu tài, cóc ba chân hoặc mở cổng, kê giường cũng tốt.</li>
              <li>- Góc phía Tây có nạn ốm đau về phổi, huyết hoặc hỏa hoạn: gia chủ nên đặt vào đó một hốc đá thạch anh để hóa  giải.</li>
            </ul>

            <h5>f.Nhà tọa Nam hướng Bắc:</h5>
            <ul>
              <li>- Góc Đông Nam dễ bề tài lộc: gia chủ nên đặt bảo bình chiêu tài, cóc ba chân hoặc mở cổng, kê giường cũng tốt.</li>
              <li>- Góc phía Đông Bắc đầu óc lú lẫn: giả chủ không nên mở cổng, kê giường, đặt bàn học, nên dùng bồn nước hoặc hồ lô đồng đựng nước để hóa giải.</li>
              <li>- Góc Tây Bắc có họa hao tài, trai thứ bỏ nhà ra đi: gia chủ tránh mở cổng, kê giường, nên trồng cây vạn niên hoặc tùng bách để hóa giải.</li>
              <li>- Góc phía Tây công danh nhẹ bước, tài lộc dồi dào: gia chủ nên đặt nghê đồng, bảo bình chiêu tài hoặc mở cổng, kê giường để nghênh đón.</li>
            </ul>

            <h5>g.Nhà tọa Tây Nam hướng Đông Bắc:</h5>
            <ul>
              <li>- Góc Đông Nam có họa đào hoa, phá tài: Người có gia đình tránh mở cửa, kê giường. Người độc thân thì nên đặt chậu hoa tươi hoặc treo tranh hoa mẫu đơn vào đó để sớm yên bề gia thất.</li>
              <li>- Góc Đông Bắc tài lộc tươi vui: gia chủ nên đặt bảo bình chiêu tài, cóc ba chân hoặc mở cổng, kê giường nghênh đón.</li>
              <li>- Góc phía Tây Bắc công danh nhẹ bước, làm ăn thuận lợi: gia chủ nên đặt hồ lô, bảo bình chiêu tài hoặc mở cổng, kê giường để nghênh đón.</li>
              <li>- Góc phía Tây được lộc văn chương : gia chủ nên đặt bàn học, tháp văn xương tại đây để thông minh, sáng trí.</li>
            </ul>

            <h5>h.Nhà tọa Tây hướng Đông:</h5>
            <ul>
              <li>- Góc Đông Nam chứa nguồn châu báu: gia chủ nên đặt bảo bình chiêu tài, cóc ba chân, long quy bằng kim loại hoặc mở cổng, kê giường cũng tốt</li>
              <li>- Góc Đông Bắc dễ gặp đào hoa: Người có gia đình tránh mở cửa, kê giường. Người độc thân thì làm ngược lại, cũng có thể đặt chậu hoa tươi hoặc treo tranh hoa mẫu đơn vào đó để kết tóc xe tơ.</li>
              <li>- Góc Tây Bắc công danh nhẹ bước, tài lộc dồi dào: gia chủ nên đặt nghê đồng, bảo bình chiêu tài hoặc mở cổng, kê giường để nghênh đón.</li>
              <li>- Góc phía Tây chứa mầm họa hại: gia chủ nên đặt ngọc trụ để hóa giải.</li>
            </ul>
          </div>

          <h4>3. Hướng tốt xây nhà mới:</h4>
          <div class="col-sm-12">
            <p style="text-indent: 15px;line-height: 20px">
              Theo phong thủy huyền không, mỗi căn nhà, thửa đất hay ngôi mộ đều luôn luôn biến đổi. Chậm thì 20 năm tính là một vận. Nhanh thì chuyển động theo từng năm, từng tháng thậm chí từng ngày, từng giờ. Nguyên nhân của sự đổi thay đó là do sự phân công cai quản của cửu tinh, tức là 09 ngôi sao, gọi là Cửu Tinh Bắc Đẩu, luân phiên làm chủ quản, trên sai khiến quỷ thần, dưới thống lĩnh nhân gian, sức mạnh vô cùng to lớn. Nếu xây nhà mới, hướng nhà tốt nhất của Bạn chúng tôi đã phân tích trong phần LÁ SỐ TRỌN ĐỜI trên app CỐ VẤN PHONG THỦY. Đây là phương pháp biện chứng dựa trên phân tích ngũ hành trong tứ trụ (năm – tháng – ngày – giờ sinh) của bạn, nó đáng tin cậy hơn rất nhiều so với việc chỉ dùng năm sinh để luận hướng nhà theo phong thủy bát trạch. Trường hợp nhà bạn không thể có hướng tốt nhất như phân tích trong lá số, hãy đọc kỹ nội dung bên dưới để xây cho mình một căn nhà tốt nhất. Lưu ý rằng, những khuyến nghị này chỉ có giá cho những căn nhà xây dựng trong năm nay 2020.</p>
            <h5>a.Nhà hướng Nam</h5>
            <ul>
              <li>
                - Trong tất cả các năm, nên tránh xây nhà hướng Nam mà nằm trong khoảng 155 – 160 độ, 170 – 175 độ, 186 – 189 độ, 200 – 205 độ.</li>
              <li>
                - Nên xây nhà có hướng Nam xế Đông nằm trong khoảng 162 - 168 độ, sau nhà cần có núi đồi hoặc nhà lớn thì sinh dễ sinh con trai, nhân đinh mạnh khỏe, công danh thuận lợi. Nếu sau nhà có nước, sau nước có núi thì vượng cả nhân đinh lẫn tiền tài, vượng đinh hơn vượng tài.</li>
              <li>
                - Nên xây nhà có hướng Nam xế hai bên nằm trong khoảng 177 - 183 độ hoặc Nam xế Tây nằm trong khoảng 192 – 198 độ, trước nhà cần có đường, ao, sông, biển thì vượng phát tài lộc, xa nữa có thêm núi vượng cả nhân đinh nhưng vượng tài hơn vượng đinh. Nếu chỉ có núi mà không có nước thì tài lộc vất vả.</li>
            </ul>

            <h5>b.Nhà hướng Đông Nam</h5>
            <ul>
              <li>- Trong tất cả các năm, nên tránh xây nhà hướng Đông Nam mà nằm trong khoảng 155 – 160 độ, 142 – 143 độ, 125 – 130 độ và 110 – 115 độ.</li>
              <li>- Nên xây nhà có hướng Đông Nam nằm trong khoảng 147 – 153 độ hoặc nằm trong khoảng 117 – 123 độ, nếu phía trước có đường, ao, sông, biển, phía sau lại có nhà lớn, núi cao thì nhân đinh tiền tài đều vượng, hoạnh phát mau chóng.</li>
              <li>- Nên xây nhà có hướng Đông Nam nằm trong khoảng 132 - 138 độ, nếu phía sau có núi cao nhà lớn, phía trước có sông nước, ao hồ thì hoạnh phát lâu dài, con đàn cháu đống, công thành danh toại, phú quý song toàn.</li>
            </ul>

            <h5>c.Nhà hướng Đông</h5>
            <ul>
              <li>- Trong tất cả các năm, nên tránh xây nhà hướng Đông mà nằm trong khoảng 110 – 115 độ, 96 – 99 độ, 80 – 85 độ và 65 – 70 độ.</li>
              <li>- Năm nay hướng Đông phạm Ngũ Hoàng đại sát, tuyệt đối không nên xây. Trường hợp buộc phải xây thì nên mời chuyên gia phong thủy để tính toán, nên chọn các nhà có hướng như sau: </li>
              <ul>
                <li>+ Nên xây nhà có hướng Đông Nam nằm trong khoảng 102 - 108 độ, 87 – 93 độ, nếu phía sau có núi cao nhà lớn thì con đàn cháu đống, phát đinh mà không phát tài. Nếu phía sau có nước, sau nước lại có núi thì phát cả tài lẫn đinh nhưng phát đinh mạnh hơn phát tài.</li>
                <li>+ Nên xây nhà có hướng Đông Nam nằm trong khoảng 72 - 78 độ, nếu phía trước có nước thì phát lớn, xa xa lại có núi thì phát tài vượng hơn phát đinh. Nếu đằng trước chỉ có núi núi mà không có nước thì phá tài, tổn thất.</li>
              </ul>
            </ul>

            <h5>d.Nhà hướng Đông Bắc</h5>
            <ul>
              <li>- Trong tất cả các năm, nên tránh xây nhà hướng Đông mà nằm trong khoảng 65 – 70 độ, 52 - 53 độ, 35 -40 độ và 20 - 25 độ.</li>
              <li>- Nên xây nhà có hướng Đông Bắc nằm trong khoảng 27 – 33 độ, nếu phía sau có núi cao nhà lớn, phía trước có sông nước, ao hồ thì hoạnh phát lâu dài, con đàn cháu đống, công thành danh toại, phú quý song toàn.</li>
              <li>- Nên xây nhà có hướng Đông Bắc nằm trong khoảng 42 – 48 độ hoặc 57 – 63 độ nhân đinh tài lộc dồi dào, trăm năm hiếm gặp, kéo dài rất lâu. Tuy nhiên, điều kiện bắt buộc là nhà phải có cửa sau hoặc sau nhà có ao hồ, sông nước, phía trước có nhà cao núi lớn. Nếu phía sau không có cửa hoặc nước, phía trước không có núi thì nhất định sẽ gặp tai họa khó lường.</li>
            </ul>

            <h5>e.Nhà hướng Bắc</h5>
            <ul>
              <li>- Trong tất cả các năm, nên tránh xây nhà hướng Đông mà nằm trong khoảng 20 – 25 độ, 6 -9 độ, 350 - 355 độ và 335 - 340 độ.</li>
              <li>- Nên xây nhà có hướng Bắc nằm trong khoảng 357 – 3 độ hoặc Bắc xế Đông nằm trong khoảng 12 – 18 độ, sau nhà cần có núi đồi hoặc nhà lớn thì sinh dễ sinh con trai, nhân đinh mạnh khỏe, công danh thuận lợi. Nếu sau nhà có nước, sau nước có núi thì vượng cả nhân đinh lẫn tiền tài, vượng đinh hơn vượng tài.</li>
              <li>- Nên xây nhà hướng Bắc xế Tây nằm trong khoảng 342 - 348 độ, trước nhà cần có đường, ao, sông, biển thì vượng phát tài lộc, xa nữa có thêm núi vượng cả nhân đinh nhưng vượng tài hơn vượng đinh. Nếu chỉ có núi mà không có nước thì tài lộc vất vả.</li>
            </ul>

            <h5>f.Nhà hướng Tây Bắc</h5>
            <ul>
              <li>- Trong tất cả các năm, nên tránh xây nhà hướng Đông mà nằm trong khoảng 335 - 340 độ, 322 - 323 độ, 260 - 265 độ và 245 - 250 độ.</li>
              <li>- Nên xây nhà có hướng Tây Bắc nằm trong khoảng 327 - 333 độ hoặc 312 – 318 độ, nếu phía sau có núi cao nhà lớn, phía trước có sông nước, ao hồ thì hoạnh phát lâu dài, con đàn cháu đống, công thành danh toại, phú quý song toàn.</li>
              <li>- Nên xây nhà hướng Tây Bắc nằm trong khoảng 297-303 độ, trước nhà cần có đường, ao, sông, biển thì vượng phát tài lộc, xa nữa có thêm núi vượng cả nhân đinh nhưng vượng tài hơn vượng đinh. Nếu chỉ có núi mà không có nước thì tài lộc vất vả.</li>
            </ul>

            <h5>g.Nhà hướng Tây</h5>
            <ul>
              <li>- Trong tất cả các năm, nên tránh xây nhà hướng Đông mà nằm trong khoảng 290 - 295 độ, 276 - 279 độ, 260 - 265 độ và 245 - 250 độ.</li>
              <li>- Nên xây nhà hướng Tây nằm trong khoảng 267 - 273 độ hoặc Tây xế Nam nằm trong khoảng 282-288 độ, trước nhà cần có đường, ao, sông, biển thì vượng phát tài lộc, xa nữa có thêm núi vượng cả nhân đinh nhưng vượng tài hơn vượng đinh. Nếu chỉ có núi mà không có nước thì tài lộc vất vả.</li>
              <li>- Nên xây nhà có hướng Tây xế Nam nằm trong khoảng 152 - 158 độ, sau nhà cần có núi đồi hoặc nhà lớn thì sinh dễ sinh con trai, nhân đinh mạnh khỏe, công danh thuận lợi. Nếu sau nhà có nước, sau nước có núi thì vượng cả nhân đinh lẫn tiền tài, vượng đinh hơn vượng tài.</li>
            </ul>

            <h5>h.Nhà hướng Tây Nam</h5>
            <ul>
              <li>- Trong tất cả các năm, nên tránh xây nhà hướng Đông mà nằm trong khoảng 245 - 250 độ, 232 - 233 độ, 215 - 220 độ và 200 - 205 độ.</li>
              <li>- Nên xây nhà có hướng Tây Nam nằm trong khoảng 207 - 213 độ, nếu phía sau có núi cao nhà lớn, phía trước có sông nước, ao hồ thì hoạnh phát lâu dài, con đàn cháu đống, công thành danh toại, phú quý song toàn.</li>
              <li>- Nên xây nhà có hướng Đông Bắc nằm trong khoảng 222 – 228 độ hoặc 237 – 243 độ nhân đinh tài lộc dồi dào, trăm năm hiếm gặp, kéo dài rất lâu. Tuy nhiên, điều kiện bắt buộc là nhà phải có cửa sau hoặc sau nhà có ao hồ, sông nước, phía trước có nhà cao núi lớn. Nếu phía sau không có cửa hoặc nước, phía trước không có núi thì nhất định sẽ gặp tai họa khó lường.</li>
            </ul>
          </div>

          <div class="progress">
            <div 
              class="progress-bar" 
              role="progressbar" 
              aria-valuenow="10" 
              aria-valuemin="0" 
              aria-valuemax="100" 
              style="width:10%"/>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {errorToaster} from '../../services/ErrorHandler'
  import ApiConfig from '../../communicate/ApiConfig'
  import rf from '../../communicate/RequestFactory'
  import "@/assets/fonts/UTM_Ambrosia.ttf";
  import "@/assets/fonts/Roboto-Light.ttf";

  export default {
    name: "TaiLoc",
    data () {
      return {
        id: this.$route.params.id,
        base_url: ApiConfig.base_url,
        nha_o: []
      }
    },

    mounted () {
      this.getLasoContent();
    },
    methods: {

      getLasoContent () {
        rf.getRequest("ServiceRequest").getNhaO().then((res) => {
          if (res.status === 200) {
            console.log(res);
            this.nha_o = res.data.nha_o;
          } else if (res.status === 401 || res.status === 403) {
            this.$router.push({path: `/login`});
          } else {
            errorToaster("Cố vấn phong thủy", res.message);
          }
        }).catch(err => {
          errorToaster("Cố vấn phong thủy", "Xảy ra lỗi kết nối");
        })
      }
    }
  }
</script>

<style scoped>
  #main {
    width: 100%;
    height: auto;
    font-family: roboto;
  }

  .header_template{
    width: 100%;
    height: 85px;
  }
  .profile_user {
    position: absolute;

  }
  .profile_user h3 {
    font-size: 24px;
    font-family: ambrosia;
    margin-top: 10px;
    margin-bottom: 2px;
    color: #008544;
  }

  .profile_user ul {
    list-style-type: none;
    padding-left: 0;
  }
  .profile_user ul li {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 8px;
    line-height: 11px;
    color: #000000;
  }
  .logo_phongthuy {
    position: absolute;
    right: 0;
    display: flex;
    top: 0;
  }
  .logo_phongthuy .logo img {
    margin-top: 10px;
  }

  .logo_phongthuy .navbar-brand img{
    float: left;
    margin-right: 4px;
    clear: both;
    width: 32px;
    height: 32px;
  }
  .logo_phongthuy .navbar-brand span {
    font-size: 7px;
    font-family: Roboto;
    color: #000;
    position: relative;
    top: -7px;
  }
  .logo_phongthuy .navbar-brand{
    font-size: 14px;
    font-family: Roboto;
    color: #008544;
  }
  .progress {
    height: 2px;
    margin-bottom: 6px;
  }
  .progress-bar {
    height: 2px;
    background-color: #008544
  }

  .content .text-description {
    font-family: r-light;
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 13px;
    text-align: justify;
  }

  .content h3 {
    font-family: ambrosia;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    text-transform: capitalize;
    line-height: 26px;
    color: #ED1C25;
    margin-top: 0;
  }
  .content h5 {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 11px;
    line-height: 13px;
    text-align: justify;
    text-decoration-line: underline;
    color: #000000;
  }

  .content h4 {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 13px;
    text-align: justify;
    color: #000000;
  }
  .content p {
    font-family: Roboto;
    font-style: normal;
    font-size: 13px;
    line-height: 13px;
    text-align: justify;
    color: #000000;

  }
  .content ul{
    list-style-type: none;
    padding-left: 0;
  }
  .content ul li {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 20px;
    color: #000000;
    text-indent:10px
  }
  @media screen and (max-width: 320px) {
    .logo_phongthuy .navbar-brand {
      font-size: 11px;
    }

    .logo_phongthuy .navbar-brand img{
      width: 26px;
      height: 26px;
    }
    .logo_phongthuy .navbar-brand span {
      font-size: 96px;
    }
    .profile_user h3 {
      font-size: 20px;
    }
    .profile_user h5 {
      font-size: 16px;
    }
  }
  @media screen and (max-width: 360px) and (min-width: 321px) {
    .logo_phongthuy .navbar-brand span {
      font-size: 6px;
    }
    .profile_user h3 {
      font-size: 20px;
    }
    .profile_user h5 {
      font-size: 16px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/history/NhaO.vue